export const faqsPl = [
  {
    q: "Czy utrzymanie aplikacji mobilnej i webowej różni się pod kątem SLA?",
    a: "Treść SLA i monitoringu jest w praktyce taka sama niezależnie od platformy: czas reakcji, czas naprawy, kanały eskalacji i raportowanie. Różnią się narzędzia (crashlytics / App Store vs observability backendu) i typowe incydenty — nie model opieki.",
  },
  {
    q: "Co obejmuje utrzymanie aplikacji w modelu SLA?",
    a: "Zwykle: monitoring dostępności i błędów, reagowanie na incydenty w ustalonych godzinach, poprawki krytyczne, aktualizacje zależności i store/SDK, drobne rozwój w ramach pakietu godzin oraz comiesięczny raport. Zakres ustalamy po krótkim przeglądzie systemu.",
  },
  {
    q: "Czy oferujecie monitoring 24/7?",
    a: "Monitoring techniczny (alerty) może działać non-stop. Reakcja inżynierska bywa w modelu 24/7 albo w godzinach biznesowych UE — zależnie od krytyczności produktu i budżetu. Na rozmowie dobieramy poziom SLA do realnego ryzyka biznesowego.",
  },
  {
    q: "Ile kosztuje utrzymanie aplikacji?",
    a: "Najczęściej rozliczamy pakiet miesięczny (retainer) albo godziny z gwarantowanym czasem reakcji. Proste utrzymanie stabilnej aplikacji to zwykle niższy pakiet; aplikacje z płatnościami, wieloma integracjami albo store release'ami — wyższy. Orientacyjną wycenę dajemy po poznaniu stacku i historii awarii.",
  },
  {
    q: "Czy możecie przejąć utrzymanie po innym software house?",
    a: "Tak — to częsty scenariusz. Zaczynamy od dostępu do repo, CI/CD i infrastruktury, krótkiego audytu ryzyk i planu stabilizacji. Potem podpisujemy umowę utrzymaniową ze SLA. Jeśli potrzebny jest pełny audyt lub modernizacja legacy, prowadzimy to osobną ścieżką.",
  },
  {
    q: "Czy utrzymanie obejmuje też rozwój nowych funkcji?",
    a: "Tak, w uzgodnionym limicie godzin lub w osobnych sprintach. Najpierw gasimy pożary i spłacamy najgroźniejszy dług techniczny, potem dokładamy funkcje — żeby release'y nie psuły stabilności.",
  },
  {
    q: "Jak szybko reagujecie na błędy produkcyjne?",
    a: "Czas reakcji zapisujemy w SLA (np. krytyczne awarie w X godzinach roboczych). Priorytet: przywrócenie działania, potem root cause i trwała poprawka. Kanał zgłoszeń: e-mail / Slack / ticket — ustalany przy starcie współpracy.",
  },
  {
    q: "Czy potrzebuję NDA przed przekazaniem dostępu do kodu?",
    a: "Zazwyczaj tak. NDA przed dostępem do repozytorium, logów i infrastruktury to standard — potem robimy przegląd i proponujemy pakiet utrzymania albo audyt.",
  },
] as const;
